import React from 'react';
import { X } from 'lucide-react';
import { Button } from "@/src/components/ui/button.tsx";
import {
    Instagram,
    Youtube,
    Twitter,
    Music,
} from "lucide-react";
const MobileMenu = ({ isOpen, onClose }) => {
    const menuItems = [
        { label: 'TODAY', href: '/today' },
        { label: 'TRACKS', href: '/tracks' },
        { label: 'MIX OF THE WEEK', href: '/mixes' },
        { label: 'INTERVIEWS', href: '/interviews' },
        { label: 'RADIO', href: '/radio' },
        { label: 'STORE', href: '/store' }
    ];

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black/95">
            <div className="absolute top-0 right-0 p-4">
                <Button variant="ghost" size="icon" onClick={onClose} className="text-white">
                    <X className="h-6 w-6" />
                </Button>
            </div>

            <div className="flex flex-col items-center justify-center h-full">
                <nav className="w-full max-w-sm px-6 mb-10">
                    <ul className="space-y-6">
                        {menuItems.map((item) => (
                            <li key={item.label}>
                                <a
                                    href={item.href}
                                    className="block text-2xl font-bold text-white hover:text-gray-300 transition-colors py-2"
                                    onClick={onClose}
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="mt-12 flex space-x-6 socials">
                    <a href="https://soundcloud.com/the-dream-chimney" class="text-white hover:text-gray-300" target="_blank"><i
                        class="fa-brands fa-soundcloud"></i></a>
                    <a href="https://www.instagram.com/dreamchimney" class="text-white hover:text-gray-300" target="_blank" >
                        <i class="fa-brands fa-instagram"></i>
                    </a>
                    <a href="https://www.youtube.com/dreamchimney" target="_blank"
                        class="text-white hover:text-gray-300"><i class="fa-brands fa-youtube"></i></a>
                    <a href="https://bsky.app/profile/dreamchimney.com" target="_blank"
                        class="text-white hover:text-gray-300"><i class="fa-brands fa-bluesky"></i></a>
                    <a href="https://x.com/dreamchimney" target="_blank"
                        class="text-white hover:text-gray-300"><i
                            class="fa-brands fa-x-twitter"></i></a>
                </div>
            </div>
        </div>
    );
};

export default MobileMenu; 